/**
 * Converte um erro da API (ou qualquer throw) numa frase legível para o usuário.
 *
 * O `apiClient` lança `{ status, message }`, e o Nest costuma responder
 * `message` como array de mensagens de validação — sem tratamento, o alerta
 * mostrava "[object Object]" ou simplesmente nada aparecia na tela.
 */
export function describeError(error: unknown): string {
  if (!error) return 'Erro desconhecido.';

  if (typeof error === 'string') return error;

  if (typeof error === 'object') {
    const err = error as { status?: number; message?: unknown; data?: unknown };

    const fromMessage = (value: unknown): string | null => {
      if (Array.isArray(value)) {
        const items = value.filter((v): v is string => typeof v === 'string');
        return items.length ? items.join('\n• ') : null;
      }
      return typeof value === 'string' && value.trim() ? value : null;
    };

    // Mensagens de validação do Nest podem vir dentro de `data` (corpo cru).
    let detail = fromMessage(err.message);
    if (!detail && typeof err.data === 'string') {
      try {
        const parsed = JSON.parse(err.data) as { message?: unknown };
        detail = fromMessage(parsed.message);
      } catch {
        /* corpo não-JSON: ignora */
      }
    }

    if (err.status === 401) return 'Sessão expirada. Faça login novamente.';
    if (err.status === 413) {
      return 'Arquivo grande demais para envio. Use uma imagem menor.';
    }
    if (detail && err.status) return `${detail} (HTTP ${err.status})`;
    if (detail) return detail;
    if (err.status) return `Falha na comunicação com o servidor (HTTP ${err.status}).`;
  }

  if (error instanceof Error && error.message) return error.message;

  return 'Falha inesperada. Tente novamente.';
}
